import React from 'react';
import EditableFieldCell from './EditableFieldCell';

interface WebsiteCellProps {
  companyId: string;
  website?: string;
  canEdit: boolean;
  /** Persists the new website; should resolve once saved. */
  onSave: (companyId: string, website: string) => Promise<void>;
}

/**
 * Table cell for a company's website URL.
 * - When a URL exists: shows a clickable link that opens in a new tab.
 * - When missing (and editable): shows an inline text field so the user can paste one in.
 */
const WebsiteCell: React.FC<WebsiteCellProps> = ({ companyId, website, canEdit, onSave }) => (
  <EditableFieldCell
    companyId={companyId}
    value={website}
    canEdit={canEdit}
    isUrl
    allowEditExisting={false}
    onSave={onSave}
  />
);

export default WebsiteCell;
